import { PageURL } from '@router/pageURL';
import { BrokenArrowIcon } from '@components/common/Icons/BrokenArrowIcon';
import { LoginIcon } from '@components/common/Icons/LoginIcon';
import { PersonPlusIcon } from '@components/common/Icons/PersonPlusIcon';
import { TargetIcon } from '@components/common/Icons/TargetIcon';
import { CalculatorPopupLink } from './types';

export const links: CalculatorPopupLink[] = [
  {
    labelKey: 'menu.criteria',
    url: PageURL.CRITERIA,
    icon: <BrokenArrowIcon />,
  },
  {
    labelKey: 'menu.resourceHub',
    url: PageURL.RESOURCE_HUB,
    icon: <TargetIcon />,
    isSeparated: true,
  },
  {
    labelKey: 'calculator.header.signUp',
    url: PageURL.SIGNUP,
    icon: <PersonPlusIcon />,
  },
  {
    labelKey: 'calculator.header.login',
    url: PageURL.LOGIN,
    icon: <LoginIcon className={'-ml-1'} />,
  },
];
